import { render, staticRenderFns } from "./TeamsizeSelector.vue?vue&type=template&id=adaf1908&scoped=true&"
import script from "./TeamsizeSelector.vue?vue&type=script&lang=js&"
export * from "./TeamsizeSelector.vue?vue&type=script&lang=js&"
import style0 from "./TeamsizeSelector.vue?vue&type=style&index=0&id=adaf1908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaf1908",
  null
  
)

export default component.exports